var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-checkbox",
        {
          on: { change: _vm.updateStore },
          model: {
            value: _vm.check,
            callback: function($$v) {
              _vm.check = $$v
            },
            expression: "check"
          }
        },
        [_vm._v(_vm._s(_vm.$l10n.__("Rapprocher")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }